const state = {
    data: []
}

const mutations = {
    storeTgMessages (state, payload) {
        state.data = payload
    },
    storeTgMessage (state, payload) {
        state.data.unshift(payload)
    },
    updateTgMessage (state, payload) {
        let message = state.data.find(item => item.id === payload.id)

        message = payload
    },
    deleteTgMessage (state, payload) {
        state.data = state.data.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getTgMessages: state => state.data
}

export default {
    state,
    mutations,
    actions,
    getters
}
